import "./App.css";
import { Advise } from "./components/dialog/Advise";

/*
import { Routes, Route } from "react-router-dom";
import Tradicional from "./pages/Tradicional";
import { Suscripcion } from "./pages/Suscripcion";
import { Home } from "./pages/Home";
import { Navbar } from "./components/Navbar";
import { Banner } from "./components/Banner";
import { Page404 } from "./pages/Page404";
import { Dialog } from "./components/dialog/Dialog";
import { Alert } from "./components/alert/Alert";
import { useState, useEffect } from "react";
*/

function App() {
  /*
  const [showDialog, setShowDialog] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  // Show dialog when component mounts
  useEffect(() => {
    setShowDialog(true);
  }, []);

  const handleCloseDialog = () => {
    setShowDialog(false);
    setShowAlert(true); // Show the alert when dialog is closed
  };

  const handleAlertClick = () => {
    setShowAlert(false);
    setShowDialog(true); // Reopen the dialog when alert is clicked
  };
  */

  return (
    <div className="advise-container">
      <Advise />
    </div>
  );

  /* Original return statement
  return (
    <>
      <Banner />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tradicional" element={<Tradicional />} />
        <Route path="/suscripcion" element={<Suscripcion />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
      <Dialog isOpen={showDialog} onClose={handleCloseDialog} />
      <Alert isVisible={showAlert} onClick={handleAlertClick} />
    </>
  );
  */
}

export default App;
